import { AnyAssetApplication, Page } from '@mss/mss-component-library';
import React from 'react';
import Breadcrumbs from '../../Breadcrumbs';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import SelectNewAsset from './SelectNewAsset';
import ConfigureNewAsset from './ConfigureNewAsset';

function Add<AssetType extends AnyAssetApplication>() {
  const { path } = useRouteMatch();
  return (
    <Page
      breadCrumbs={<Breadcrumbs />}
      main={
        <Switch>
          <Route path={`${path}/`} exact component={SelectNewAsset} />
          <Route path={`${path}/:assetSubType`} component={ConfigureNewAsset} />
        </Switch>
      }
    />
  );
}

export default Add;
